import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setSavingWorkingProjectReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.savingWorkingProject = action.payload;
    if (!action.payload) {
      state.saveId = null;
      state.refetchProjectAfterSave = false;
    }
  });
};

export default setSavingWorkingProjectReducer;
